import React from 'react'
import { Route } from 'react-router-dom'
import { SourceRoute } from '../routers/router'

const RouteWithOtherProps: React.FC<SourceRoute> = (route) => {
    return typeof route.component !== 'undefined' ? (
        <Route
            path={route.path}
            render={() => {
                if (route.component) {
                    return (
                        <route.component
                            path={route.path}
                            title={route.title}
                            icon={route.icon}
                            routes={route.routes}
                        />
                    )
                }
            }}
        />
    ) : null
}

export default RouteWithOtherProps
